import { defineRule } from "vee-validate";
import baseValidators from "scriptsShared/Validators/baseValidators.js";

defineRule("zipCode", value => {
    return baseValidators.zipCode(value) || "Je požadováno validní poštovní směrovací číslo";
});

defineRule("identificationNumberCz", value => {
    return baseValidators.identificationNumber(value) || "Je požadováno validní rodné číslo";
});

defineRule("ic", value => {
    return baseValidators.ic(value) || "Je požadováno validní IČ";
});

defineRule("phone", value => {
    if (!value) {
        return true;
    }
    
    const result = baseValidators.phone(value);
    return result.valid || "Je požadováno validní telefonní číslo";
});

defineRule("date", value => {
    return baseValidators.date(value) || "Je požadováno datum ve formátu DD.MM.RRRR";
});

defineRule("dateBeforeToday", (value, { excludeToday }) => {
    return baseValidators.dateBeforeToday(value, excludeToday) || "Datum musí být v minulosti";
});

defineRule("dateAfterToday", (value, { excludeToday }) => {
    return baseValidators.dateAfterToday(value, excludeToday) || "Datum musí být v budoucnu";
});

defineRule("cisloOPR", value => {
    return baseValidators.validateOPR(value) || "Je požadováno validní číslo OP";
});

defineRule("cisloRP", value => {
    return baseValidators.validateRP(value) || "Je požadováno validní číslo ŘP, zadávejte prosím bez mezery mezi písmeny a číslicemi";
});

defineRule("originatorHB", value => {
    return baseValidators.originatorHB(value) || "Je požadováno validní provizní číslo";
});

defineRule("rateDiscountHB", (value, [min, max]) => {
    return baseValidators.rateDiscountHB(value, min, max) || `Výše slevy musí být desetinné číslo v intervalu ${min} až ${max}`;
});

defineRule("requiredAppl", (value, { application, applicantTypes }) => {
    let requiredTypesValidated = baseValidators.requiredAppl(value, application, applicantTypes);
    if (requiredTypesValidated.length === 0) {
        return true;
    }
    let requiredTypesNames = requiredTypesValidated.map(d => d.name).join(", ");
    return `Alespoň jeden žadatel musí být typu: ${requiredTypesNames}`;
});

defineRule("onlyOnceAppl", (value, { application, curApplicantType }) => {
    return baseValidators.onlyOnceAppl(value, application, curApplicantType) || "Tento typ žadatele smí být zvolen pouze pro jednoho žadatele";
});

defineRule("selectValue", (value, args) => {
    if (value === null || value === undefined) {
        return true;
    }
    if (args && args.includes(value)) {
        return true;
    }
    return `Hodnota pole musí být validní`;
});